import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api";
import axios from "axios";
// import api from "../../api";


// const responsee = await axios.get(`https://backend.nahdetmisr.com:10443/api/Blogs/GetAll`);
// console.log(responsee);



// Thunk to fetch all blogs
export const getDataBlogs = createAsyncThunk("blogs/getDataBlogs", async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const response = await api.get(`/api/Blogs/GetAll`);
    console.log(response);
    
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

// Thunk to fetch blogs details by ID
export const getDataBlogsDetails = createAsyncThunk("blogs/getDataBlogsDetails", async (id, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const response = await api.get(`/api/Blogs/GetById?id=${id}`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

export const getDataBlogsSearch = createAsyncThunk("blogs/getDataBlogsSearch", async (searchKey, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const response = await api.get(
      `/api/Blogs/searchBlog?searchKey=${searchKey}`
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

const initialState = {
  blogs: [],
  blogsDetails: null,
  blogsSearch: [],
  isLoading: false,
  error: null,
};

const blogsSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {
    resetBlogsSearch(state) {
      state.blogsSearch = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDataBlogs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDataBlogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null; // Clear any previous error
        // Update the blogs state with the fetched data
        state.blogs = action.payload;
      })
      .addCase(getDataBlogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Add similar logic for other actions...
      .addCase(getDataBlogsDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDataBlogsDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.blogsDetails = action.payload;
      })
      .addCase(getDataBlogsDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getDataBlogsSearch.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDataBlogsSearch.fulfilled, (state, action) => {
        state.isLoading = false;
        state.blogsSearch = action.payload;
      })
      .addCase(getDataBlogsSearch.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetBlogsSearch } = blogsSlice.actions;

export default blogsSlice.reducer;